export function isAppRunningInProduction() {
  console.info("app mode: ", import.meta.env.MODE)

  if (import.meta.env.MODE) {
    if (import.meta.env.MODE === 'production') {
      return true
    } else {
      return false
    }
  }
  return true
}

export function isViteAppRunningInProduction() {
  console.info("app mode: ", import.meta.env.MODE)

  if (import.meta.env.VITE_ENV) {
    if (import.meta.env.VITE_ENV === 'PRODUCTION') {
      return true
    } else {
      return false
    }
  }
  return true
}

export async function getIpAddress() {
  try {
    // Create an AbortController for timeout
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 5000) // 5 second timeout
    
    const response = await fetch('https://api.ipify.org?format=json', {
      signal: controller.signal,
    })
    
    clearTimeout(timeoutId)
    
    if (!response.ok) {
      console.warn('[getIpAddress] Failed to fetch IP address:', response.status, response.statusText)
      return null
    }
    
    const data = await response.json()
    return data?.ip || null
  } catch (error) {
    // Silently fail - IP address is optional
    if (error.name !== 'AbortError') {
      console.warn('[getIpAddress] Error fetching IP address:', error.message)
    }
    return null
  }
}